import { NgIf, AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';

import { ConfigService } from '@dav-core/services/config.service';

@Component({
  selector: 'app-initial-loader',
  templateUrl: './initial-loader.component.html',
  styleUrls: ['./initial-loader.component.scss'],
  standalone: true,
  imports: [NgIf, AsyncPipe],
})
export class InitialLoaderComponent {
  constructor(public configService: ConfigService) {}
}
